import { staleTimes, useQuery } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import { useDebouncedValue } from '../useDebouncedValue.ts';
import { queryKeys, usePageContext } from '../usePageContext.ts';

const MIN_LOOKUP_LENGTH = 2;
const LOOKUP_DELAY_MS = 250;

export const useOrderLookup = (api: TypedClient, text: string) => {
  const { tenantId } = usePageContext();
  const settled = useDebouncedValue(text.trim(), LOOKUP_DELAY_MS);
  const enabled = settled.length >= MIN_LOOKUP_LENGTH;
  const query = useQuery({
    queryKey: queryKeys.orders(tenantId, { lookup: settled }),
    queryFn: () => api.post('/admin/orders/lookup', { body: { text: settled } }),
    enabled,
    staleTime: staleTimes.orders,
  });
  return {
    orders: enabled ? (query.data?.items ?? []) : [],
    busy: enabled && query.isFetching,
    active: enabled,
  };
};
